import { render, staticRenderFns } from "./EmailBounceList.vue?vue&type=template&id=124eccf9"
import script from "./EmailBounceList.vue?vue&type=script&lang=js"
export * from "./EmailBounceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports